import { useState } from "react";
import "../../Assets/Scss/Foundation_Object.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import axios from "axios";
import { Draggable } from "react-drag-reorder";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  allBusinessUnitURL,
  allDepartmentURL,
  allDivisionURL,
  allLegalEntitiesURL,
  allLocationURL,
  allPayGradeURL,
  allPayLevelURL,
  creatBusinessUnitURL,
  creatDepartmentURL,
  creatLegalEntityURL,
  creatPayGradeURL,
  creatPayLevelURL,
  createDivisionURL,
  createLocationURL,
  editLocationUrl,
  deleteLocationUrl,
  allJobRolesURL,
  addJobRolesURL,
  deleteJobRolesURL,
  updateJobRolesURL,
  editDeparmentUrl,
  allEmployeeURL,
  deleteDepartmentUrl,
  deleteDivisionUrl,
  editDivisionUrl,
  editBusinessUnitUrl,
  deleteBusinessUnitUrl,
  editPayGradeUrl,
  deletePayGradeUrl,
  editPayLevelUrl,
  deletePayLevelUrl,
  editLegalEntitiesURL,
  deleteLegalEntitiesURL
} from "../../Library/URLs";
import { v4 as uuid } from "uuid";
import SelectField from "../../Components/SelectField";

import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  CreateJobroles,
  DeleteJobroles,
  EditJobroles,
  ViewJobDialog,
} from "./modals/JobRoles";
import {
  CreateLocationDialog,
  DeleteLocationDialog,
  EditLocationDialog,
  ViewLocationDialog,
} from "./modals/Location";
import {
  CreateLevelsDialog,
  DeleteLevelDialog,
  EditLevelDialog,
  ViewLevelDialog,
} from "./modals/Levels";
import {
  CreateGradesDialog,
  DeleteGradeDialog,
  EditGradeDialog,
  ViewGradeDialog,
} from "./modals/Grades";
import {
  CreateDepartmentDialog,
  DeleteDepartmentDialog,
  EditDepartmentDialog,
  ViewDepartmentDialog,
} from "./modals/Department";
import {
  CreateDivisionDialog,
  DeleteDivisionDialog,
  EditDivisionDialog,
  ViewDivisionDialog,
} from "./modals/Division";
import {
  CreateBusinessUnitDialog,
  DeleteBusinessUnitDialog,
  EditBusinessUnitDialog,
  ViewBusinessUnitDialog,
} from "./modals/BusinessUnit";
import {
  CreateLegalEntityDialog,
  DeleteLegalDialog,
  EditLegalDialog,
  ViewLegalDialog,
} from "./modals/LegalEntity";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    // minWidth: '520px',
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  outline: "none",
  boxShadow: 24,
  borderRadius: "3px",
  p: 1,
};

const FoundationObject = ({ loadEndpoint }) => {
  const unique_id = uuid();
  const { companyid } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { User } = useSelector((state) => state.payroll);
  const proxyEmployee = useSelector((state) => state.payroll.Proxy);

  const [isLoading, setloading] = useState(false);
  const [Country, setCountry] = useState("");

  const [AllEntity, setAllEntity] = useState("");
  const [LegalEntity, setLegalEntity] = useState({
    name: "",
    description: "",
    hod: ""
  })

  const [AllBusinessUnit, setAllBusinessUnit] = useState("");
  const [BusinessUnit, setBusiness] = useState({
    name: "",
    head_of_unit: "",
    description: "",
    effective_start_date: "",
    effective_status: "",
  });

  const [AllDivision, setAllDivision] = useState("");
  const [DivisionUnit, setDivision] = useState({
    name: "",
    hod: "",
    description: "",
    effective_start_date: "",
    effective_status: "",
  });

  const [AllDepartment, setAllDepartment] = useState("");
  const [DepartmentUnit, setDepartment] = useState({
    name: "",
    description: "",
    head_of_department: "",
    effective_start_date: "",
    effective_status: "",
  });

  const [AllGrade, setAllGrade] = useState("");
  const [Grade, setGrade] = useState({
    name: "",
    description: "",
    grade_status: "",
    start_date: "",
    status: "",
    min_gross_salary: "",
    max_gross_salary: "",
  });

  const [AllLevel, setAllLevel] = useState("");
  const [PayLevel, setPayLevel] = useState({
    name: "",
    description: "",
    level: "",
    start_date: "",
    status: "",
    pay_grade_id: "",
  });

  const [AllLocation, setAllLocation] = useState("");
  const [Location, setLocation] = useState({
    name: "",
    description: "",
    start_date: "",
  });

  const [AllJobs, setAllJobs] = useState("");
  const [Job, setJob] = useState({
    name: "",
  });

  const [Show, setShow] = useState(false);
  const [Legalopen, setLegalopen] = useState(false);
  const [editLegal, setEditLegal] = useState(null);
  const [deleteLegal, setDeleteLegal] = useState(null);
  const [LegalViewopen, setLegalViewopen] = useState(null);

  const legalhandle = () => {
    setShow((pr) => !pr);
    setGradeShow(false);
    setJobShow(false);
    setLocateShow(false);
    setCostShow(false);
    setDeptShow(false);
    setBsShow(false);
    setDsShow(false);
    setPayLevelShow(false);
  };

  const [BsShow, setBsShow] = useState(false);
  const [editBs, setEditBs] = useState(null);
  const [deleteBs, setDeleteBs] = useState(null);
  const [BsViewopen, setBsViewOpen] = useState(null);

  const Bshandle = () => {
    setBsShow((pr) => !pr);
    setGradeShow(false);
    setJobShow(false);
    setLocateShow(false);
    setCostShow(false);
    setDeptShow(false);
    setShow(false);
    setDsShow(false);
    setPayLevelShow(false);
  };

  const [DsShow, setDsShow] = useState(false);
  const [editDs, setEditDs] = useState(null);
  const [deleteDs, setDeleteDs] = useState(null);
  const [DsViewopen, setDsViewopen] = useState(null);

  const Dshandle = () => {
    setDsShow((pr) => !pr);
    setGradeShow(false);
    setJobShow(false);
    setLocateShow(false);
    setCostShow(false);
    setDeptShow(false);
    setBsShow(false);
    setShow(false);
    setPayLevelShow(false);
  };

  const [DeptShow, setDeptShow] = useState(false);
  const [editDept, setEditDept] = useState(null);
  const [deleteDept, setDeleteDept] = useState(null);
  const [DeptViewopen, setDeptViewopen] = useState(null);

  const Depthandle = () => {
    setDeptShow((pr) => !pr);
    setGradeShow(false);
    setJobShow(false);
    setLocateShow(false);
    setCostShow(false);
    setDsShow(false);
    setBsShow(false);
    setShow(false);
    setPayLevelShow(false);
  };

  const [CostShow, setCostShow] = useState(false);

  const Costhandle = () => {
    setCostShow((pr) => !pr);
    setGradeShow(false);
    setJobShow(false);
    setLocateShow(false);
    setDeptShow(false);
    setDsShow(false);
    setBsShow(false);
    setShow(false);
    setPayLevelShow(false);
  };

  const [GradeShow, setGradeShow] = useState(false);
  const [editGrade, setEditGrade] = useState(null);
  const [deleteGrade, setDeleteGrade] = useState(null);
  const [GradeViewopen, setGradeViewopen] = useState(null);

  const Gradehandle = () => {
    setGradeShow((pr) => !pr);
    setCostShow(false);
    setJobShow(false);
    setLocateShow(false);
    setDeptShow(false);
    setDsShow(false);
    setBsShow(false);
    setShow(false);
    setPayLevelShow(false);
  };

  const [PayLevelShow, setPayLevelShow] = useState(false);
  const [editPayLevel, setEditPayLevel] = useState(null);
  const [deletePayLevel, setDeletePayLevel] = useState(null);
  const [LevelViewopen, setLevelViewopen] = useState(null);

  const Levelhandle = () => {
    setPayLevelShow((pr) => !pr);
    setGradeShow(false);
    setJobShow(false);
    setCostShow(false);
    setLocateShow(false);
    setDeptShow(false);
    setDsShow(false);
    setBsShow(false);
    setShow(false);
  };

  const [LocateShow, setLocateShow] = useState(false);
  const [editLocate, setEditLocate] = useState(null);
  const [deleteLocate, setDeleteLocate] = useState(null);
  const [LocateViewopen, setLocateViewopen] = useState(null);

  const Locatehandle = () => {
    setLocateShow((pr) => !pr);
    setJobShow(false);
    setGradeShow(false);
    setCostShow(false);
    setDeptShow(false);
    setDsShow(false);
    setBsShow(false);
    setShow(false);
    setPayLevelShow(false);
  };

  const [JobShow, setJobShow] = useState(false);
  const [EditJob, setEditJob] = useState(null);
  const [DeleteJob, setDeleteJob] = useState(null);
  const [JobViewopen, setJobViewopen] = useState(null);

  const Jobhandle = () => {
    setJobShow((pr) => !pr);
    setLocateShow(false);
    setGradeShow(false);
    setCostShow(false);
    setDeptShow(false);
    setDsShow(false);
    setBsShow(false);
    setShow(false);
    setPayLevelShow(false);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const LegalhandleOpen = () => setLegalopen(true);
  const LegalhandleClose = () => {setLegalopen(false);setLegalEntity({
    name: "",
    description: "",
    hod: ""
  })};
  const handleEditLegalOpen = (id) => {
    let selectedLegal = AllEntity?.find((item) => item.id===id);
    setLegalEntity({
      ...LegalEntity,
      name: selectedLegal?.name,
      description: selectedLegal?.description
    })
    setEditLegal(id);
  }
  const handleEditLegalClose = () => {setEditLegal(null);setLegalEntity({
    name: "",
    description: "",
    hod: ""
  })};
  const handleDeleteLegalOpen = (id) => setDeleteLegal(id);
  const handleDeleteLegalClose = () => setDeleteLegal(null);
  const handleViewLegalOpen = (item) => setLegalViewopen(item);
  const handleViewLegalClose = () => setLegalViewopen(null);

  const [Bsopen, setBsOpen] = useState(false);
  const BshandleOpen = () => setBsOpen(true);
  const BshandleClose = () => setBsOpen(false);
  const handleEditBsOpen = (id) => {
    let selectedBs =
      AllBusinessUnit !== "" && AllBusinessUnit?.find((item) => item.id === id);
    setBusiness({
      ...BusinessUnit,
      name: selectedBs.name,
      description: selectedBs?.description,
      head_of_unit: selectedBs?.head_of_unit,
    });
    setEditBs(id);
  };
  const handleEditBsClose = () => setEditBs(null);
  const handleDeleteBsOpen = (id) => setDeleteBs(id);
  const handleDeleteBsClose = () => setDeleteBs(null);
  const handleViewBsOpen = (item) => setBsViewOpen(item);
  const handleViewBsClose = () => setBsViewOpen(null);

  const [Dsopen, setDsOpen] = useState(false);
  const DshandleOpen = () => setDsOpen(true);
  const DshandleClose = () => setDsOpen(false);
  const handleEditDsOpen = (id) => {
    let selectedDs =
      AllDivision !== "" && AllDivision?.find((item) => item.id === id);
    setDivision({
      ...DivisionUnit,
      name: selectedDs?.name,
      description: selectedDs?.description,
      hod: selectedDs?.hod,
    });
    setEditDs(id);
  };
  const handleEditDsClose = () => setEditDs(null);
  const handleDeleteDsOpen = (id) => setDeleteDs(id);
  const handleDeleteDsClose = () => setDeleteDs(null);
  const handleViewDsOpen = (item) => setDsViewopen(item);
  const handleViewDsClose = () => setDsViewopen(null);

  const [Deptopen, setDeptOpen] = useState(false);
  const DepthandleOpen = () => setDeptOpen(true);
  const DepthandleClose = () => setDeptOpen(false);
  const handleEditDeptOpen = (id) => {
    let selectedDept =
      AllDepartment !== "" && AllDepartment.find((item) => item.id === id);
    setDepartment({
      ...DepartmentUnit,
      name: selectedDept?.name,
      description: selectedDept?.description,
      head_of_department: selectedDept?.head_of_department,
    });
    setEditDept(id);
  };
  const handleEditDeptClose = () => setEditDept(null);
  const handleDeleteDeptOpen = (id) => setDeleteDept(id);
  const handleDeleteDeptClose = () => setDeleteDept(null);
  const handleViewDeptOpen = (item) => setDeptViewopen(item);
  const handleViewDeptClose = () => setDeptViewopen(null);

  const [Costopen, setCostOpen] = useState(false);
  const CosthandleOpen = () => setCostOpen(true);
  const CosthandleClose = () => setCostOpen(false);

  const [openGrade, setOpenGrade] = useState(false);
  const gradehandleOpen = () => setOpenGrade(true);
  const gradehandleClose = () => setOpenGrade(false);
  const handleEditGradeOpen = (id) => {
    let selectedGrade =
      AllGrade !== "" && AllGrade.find((item) => item.id === id);
    setGrade({
      ...Grade,
      name: selectedGrade?.grade,
      description: selectedGrade?.description,
      // grade_status: selectedGrade?.grade_status,
      start_date: selectedGrade?.start_date,
      status: selectedGrade?.status,
      min_gross_salary: selectedGrade?.min_gross_salary,
      max_gross_salary: selectedGrade?.max_gross_salary,
    });
    setEditGrade(id);
  };
  const handleEditGradeClose = () => setEditGrade(null);
  const handleDeleteGradeOpen = (id) => setDeleteGrade(id);
  const handleDeleteGradeClose = () => setDeleteGrade(null);
  const handleViewGradeOpen = (item) => setGradeViewopen(item);
  const handleViewGradeClose = () => setGradeViewopen(null);

  const [openLevel, setOpenLevel] = useState(false);
  const LevelhandleOpen = () => setOpenLevel(true);
  const LevelhandleClose = () => setOpenLevel(false);
  const handleEditPayLevelOpen = (id) => {
    let selectedPayLevel =
      AllLevel !== "" && AllLevel.find((item) => item.id === id);
    setPayLevel({
      ...PayLevel,
      name: selectedPayLevel?.level,
      description: selectedPayLevel?.description,
      level: selectedPayLevel?.level,
      start_date: selectedPayLevel?.start_date,
      status: selectedPayLevel?.status,
      pay_grade_id: selectedPayLevel?.pay_grade_id,
    });
    setEditPayLevel(id);
  };
  const handleEditPayLevelClose = () => setEditPayLevel(null);
  const handleDeletePayLevelOpen = (id) => setDeletePayLevel(id);
  const handleDeletePayLevelClose = () => setDeletePayLevel(null);
  const handleViewLevelOpen = (item) => setLevelViewopen(item);
  const handleViewLevelClose = () => setLevelViewopen(null);

  const [Locateopen, setLocateOpen] = useState(false);
  const LocatehandleOpen = () => setLocateOpen(true);
  const LocatehandleClose = () => setLocateOpen(false);
  const handleEditLocateOpen = (id) => {
    let selectedLocation =
      AllLocation !== "" && AllLocation?.find((item) => item?.id === id);
    setLocation({
      ...Location,
      name: selectedLocation?.location,
      description: selectedLocation?.description,
      head_of_location: selectedLocation?.head_of_location,
    });
    setEditLocate(id);
  };
  const handleEditLocateClose = () => setEditLocate(null);
  const handleDeleteLocateOpen = (id) => setDeleteLocate(id);
  const handleDeleteLocateClose = () => setDeleteLocate(null);
  const handleViewLocateOpen = (item) => setLocateViewopen(item);
  const handleViewLocateClose = () => setLocateViewopen(null);

  const [JobOpen, setJobOpen] = useState(false);
  const JobhandleOpen = () => setJobOpen(true);
  const JobhandleClose = () => setJobOpen(false);
  const handleEditJobOpen = (id) => {
    let selectedJob =
      AllJobs !== "" && AllJobs?.find((item) => item?.id === id);
    setJob({
      ...Job,
      name: selectedJob?.name,
    });
    setEditJob(id);
  };
  const handleEditJobClose = () => setEditJob(null);
  const handleDeleteJobOpen = (id) => setDeleteJob(id);
  const handleDeleteJobClose = () => setDeleteJob(null);
  const handleViewJobOpen = (item) => setJobViewopen(item);
  const handleViewJobClose = () => setJobViewopen(null);

  const [value, setvalue] = useState(0);

  const [detail, setdetail] = useState([
    {
      name: "",
      description: "",
      effectiveStatus: "",
      effectiveStartDate: "",
      headOfUnit: "",
    },
  ]);

  const [Costvalue, setCostvalue] = useState(0);

  const [CostCenter, setCostCenter] = useState([
    {
      name: "",
      description: "",
      effectiveStatus: "",
      effectiveStartDate: "",
      parentCostCenter: "",
      costCenterManager: "",
    },
  ]);

  const [Locationvalue, setLocationvalue] = useState(0);

  const [LocGroupvalue, setLocGroupvalue] = useState(0);

  const [LocationGroup, setLocationGroup] = useState([
    {
      name: "",
      description: "",
      status: "",
      startDate: "",
    },
  ]);

  const [PayGradevalue, setPayGradevalue] = useState(0);

  const [PayGrade, setPayGrade] = useState([
    {
      name: "",
      description: "",
      status: "",
      startDate: "",
      payGradeLevel: "",
    },
  ]);

  const [Geovalue, setGeovalue] = useState(0);

  const [Geozone, setGeozone] = useState([
    {
      name: "",
      description: "",
      status: "",
      startDate: "",
      adjustmentPercentage: "",
    },
  ]);

  const [JobFuncvalue, setJobFuncvalue] = useState(0);

  const [JobFunction, setJobFunction] = useState([
    {
      name: "",
      status: "",
      startDate: "",
      parentJobFunction: "",
      jobFunctionType: "",
    },
  ]);

  const [JobClassicvalue, setJobClassicvalue] = useState(0);

  const [AllEmployee, setAllEmployee] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);

  const [JobClassification, setJobClassification] = useState([
    {
      name: "",
      description: "",
      effectiveStatus: "",
      effectiveStartDate: "",
      payGrade: "",
      jobFunction: "",
      parentJobClassification: "",
      defaultJobLevel: "",
    },
  ]);

  const Addjobclass = () => {
    const data = {
      name: "",
      description: "",
      effectiveStatus: "",
      effectiveStartDate: "",
      payGrade: "",
      jobFunction: "",
      parentJobClassification: "",
      defaultJobLevel: "",
    };
    setJobClassification([...JobClassification, data]);
  };

  const Minusjobclass = (index) => {
    const data = [...JobClassification];
    data.splice(index, 1);
    setJobClassification(data);
  };

  const handlejobclass = (e, index) => {
    e.preventDefault();
    const data = [...JobClassification];
    data[index][e.target.name] = e.target.value;
    setJobClassification(data);
  };

  const submitjobclass = () => {
    console.log("response data", JobClassification);
  };

  const Addpaygrade = () => {
    const data = {
      name: "",
      description: "",
      status: "",
      startDate: "",
      payGradeLevel: "",
    };
    setPayGrade([...PayGrade, data]);
  };

  const Minuspaygrade = (index) => {
    const data = [...PayGrade];
    data.splice(index, 1);
    setPayGrade(data);
  };

  const handlepaygrade = (e, index) => {
    e.preventDefault();
    const data = [...PayGrade];
    data[index][e.target.name] = e.target.value;
    setPayGrade(data);
  };

  const submitpaygrade = () => {
    console.log("response data", PayGrade);
  };

  const Addgeo = () => {
    const data = {
      name: "",
      description: "",
      status: "",
      startDate: "",
      adjustmentPercentage: "",
    };
    setGeozone([...Geozone, data]);
  };

  const Minusgeo = (index) => {
    const data = [...Geozone];
    data.splice(index, 1);
    setGeozone(data);
  };

  const handlegeo = (e, index) => {
    e.preventDefault();
    const data = [...Geozone];
    data[index][e.target.name] = e.target.value;
    setGeozone(data);
  };

  const submitgeo = () => {
    console.log("response data", Geozone);
  };

  const Add = () => {
    const data = {
      name: "",
      description: "",
      effectiveStatus: "",
      effectiveStartDate: "",
      headOfUnit: "",
    };
    setdetail([...detail, data]);
  };

  const Minus = (index) => {
    const data = [...detail];
    data.splice(index, 1);
    setdetail(data);
  };

  const handle = (e, index) => {
    e.preventDefault();
    const data = [...detail];
    data[index][e.target.name] = e.target.value;
    setdetail(data);
  };

  const submit = () => {
    console.log("response data", detail);
  };

  const AddCost = () => {
    const data = {
      name: "",
      description: "",
      effectiveStatus: "",
      effectiveStartDate: "",
      parentCostCenter: "",
      costCenterManager: "",
    };
    setCostCenter([...CostCenter, data]);
  };

  const MinusCost = (index) => {
    const data = [...CostCenter];
    data.splice(index, 1);
    setCostCenter(data);
  };

  const handleCost = (e, index) => {
    e.preventDefault();
    const data = [...CostCenter];
    data[index][e.target.name] = e.target.value;
    setCostCenter(data);
  };

  const submitCost = () => {
    console.log("response data", CostCenter);
  };

  const Addlocation = () => {
    const data = {
      name: "",
      description: "",
      status: "",
      startDate: "",
      locationGroup: "",
      timezone: "",
      standardHours: "",
    };
    setLocation([...Location, data]);
  };

  const Minuslocation = (index) => {
    const data = [...Location];
    data.splice(index, 1);
    setLocation(data);
  };

  const handlelocation = (e, index) => {
    e.preventDefault();
    const data = [...Location];
    data[index][e.target.name] = e.target.value;
    setLocation(data);
  };

  const fetch = async () => {
    // console.log('all employee API is call')
    const raw = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allEmployeeURL, raw)
      .then((res) => {
        if (res.data.success === true) {
          const itemres = res.data.data?.map((item) => {
            return {
              label: `${item.first_name} ${item.last_name}`,
              value: item?.id,
            };
          });
          setAllEmployee(itemres);
        }

        // console.log('length',res.data.employees.length)
      })
      .catch((err) => {
        // console.log('error'+err.message)
      });
  };

  const submitlocation = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      name: Location.name,
      description: Location.description,
      start_date: Location.start_date,
      head_of_location: Location?.head_of_location,
    };
    await axios.post(createLocationURL, data).then((res) => {
      if (res.data.success === true) {
        LocatehandleClose();
        toast.success(res.data.data);
      } else toast.error(res.data.message);
      console.log("location res", res);
      setloading(false);
    });
  };

  const Addlocgr = () => {
    const data = {
      name: "",
      description: "",
      status: "",
      startDate: "",
    };
    setLocationGroup([...LocationGroup, data]);
  };

  const Minuslocgr = (index) => {
    const data = [...LocationGroup];
    data.splice(index, 1);
    setLocationGroup(data);
  };

  const handlelocgr = (e, index) => {
    e.preventDefault();
    const data = [...LocationGroup];
    data[index][e.target.name] = e.target.value;
    setLocationGroup(data);
  };

  const submitlocgr = () => {
    console.log("response data", LocationGroup);
  };

  const Addjobfun = () => {
    const data = {
      name: "",
      status: "",
      startDate: "",
      parentJobFunction: "",
      jobFunctionType: "",
    };
    setJobFunction([...JobFunction, data]);
  };

  const Minusjobfun = (index) => {
    const data = [...JobFunction];
    data.splice(index, 1);
    setJobFunction(data);
  };

  const handlejobfun = (e, index) => {
    e.preventDefault();
    const data = [...JobFunction];
    data[index][e.target.name] = e.target.value;
    setJobFunction(data);
  };

  const submitjobfun = () => {
    console.log("response data", JobFunction);
  };

  // const fetch = async () => {
  //   console.log("foundation api call...");
  //   await axios
  //     .get("https://vpheemn.com/get-all-foundation-object.php")
  //     .then((res) => {
  //       console.log("foundation res", res);
  //     });
  // };

  const [words, setword] = useState(["Hello", "Hi", "How are you", "Cool"]);

  const getChangedPos = (currentPos, newPos) => {
    console.log(currentPos, newPos);
  };

  const GetAllCountry = async () => {
    await axios.get("https://vpheemn.com/get-all-countries.php").then((res) => {
      // console.log('country',res.data.all_countries)
      setCountry(res.data.all_countries);
    });
  };

  const AllLegalEntity = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allLegalEntitiesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllEntity(res.data.data);
        }
      })
      .catch((err) => {});
  };
  const createLegalEntity = async (Post) => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      name: Post.name,
      country: Post.countryOfRegistration,
      description: Post.description,
      hod: "75",
      effective_start_date: Post.effectiveStartDate,
      effective_status: Post.effectiveStatus,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    await axios
      .post(creatLegalEntityURL, data)
      .then((res) => {
        if (res.data.success === true) {
          handleClose();
          AllLegalEntity();
          // setLeg
          toast.success(res.data.message);
        }
        setloading(false);
      })
      .catch((err) => {
        handleClose();
        // toast.error(err.message)
        setloading(false);
      });
  };

  const updateLegalEntity = async (Post) => {
    setloading(true);
    const data = {
      user_id: User.id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: User.company_id,
      legal_country_specific_id: editLegal,
      name: LegalEntity.name,
      country: Post.countryOfRegistration,
      description: LegalEntity.description,
      // hod: LegalEntity.hod,
      effective_start_date: Post.effectiveStartDate,
      effective_status: Post.effectiveStatus,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    await axios
      .post(editLegalEntitiesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          handleEditLegalClose();
          AllLegalEntity();
          // setLeg
          toast.success(res.data.data);
          setLegalEntity({
            name: "",
            description: ""
          })
        } else {
          toast.error(res?.data?.message)
        }
        setloading(false);
      })
      .catch((err) => {
        handleClose();
        // toast.error(err.message)
        setloading(false);
      });
  };

  const deleteLegalEntity = async (Post) => {
    setloading(true);
    const data = {
      user_id: User.id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: User.company_id,
      legal_country_specific_id: deleteLegal,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    await axios
      .post(deleteLegalEntitiesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          handleDeleteLegalClose();
          AllLegalEntity();
          // setLeg
          toast.success(res.data.data);
        } else {
          toast.error(res?.data?.message)
        }
        setloading(false);
      })
      .catch((err) => {
        handleClose();
        // toast.error(err.message)
        setloading(false);
      });
  };

  const Legalsubmit = (data) => {
    createLegalEntity(data);
  };

  const FetchAllBusinessUnit = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allBusinessUnitURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllBusinessUnit(res.data.data);
          // console.log('all Business unit',res.data.data)
        }
      })
      .catch((err) => {
        // console.log('Get all Business unit error',err.message)
      });
  };
  const createBusinessUnit = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      name: BusinessUnit.name,
      description: BusinessUnit.description,
      head_of_business_unit: BusinessUnit?.head_of_business_unit,
      effective_start_date: BusinessUnit.effective_start_date,
      effective_status: BusinessUnit.effective_status,
    };
    await axios
      .post(creatBusinessUnitURL, data)
      .then((res) => {
        if (res.data.success === true) {
          BshandleClose();
          FetchAllBusinessUnit();
          setBusiness({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          toast.success(res.data.message);
        }
        setloading(false);
      })
      .catch((err) => {
        BshandleClose();
        // toast.error(err.message)
        setloading(false);
      });
  };

  const updateBusinessUnit = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      business_unit_id: editBs,
      name: BusinessUnit.name,
      description: BusinessUnit.description,
      head_of_business_unit: BusinessUnit?.head_of_business_unit,
      effective_start_date: BusinessUnit.effective_start_date,
      effective_status: BusinessUnit.effective_status,
    };
    // console.log('create job roles', data)
    await axios
      .post(editBusinessUnitUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          BshandleClose();
          FetchAllBusinessUnit();
          setBusiness({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          setEditBs(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        BshandleClose();
        setloading(false);
      });
  };

  const deleteBusinessUnit = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      business_unit_id: deleteBs,
    };
    // console.log('create job roles', data)
    await axios
      .post(deleteBusinessUnitUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          BshandleClose();
          FetchAllBusinessUnit();
          setBusiness({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          setDeleteBs(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        BshandleClose();
        setloading(false);
      });
  };

  const FetchAllDivision = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allDivisionURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllDivision(res.data.data);
          // console.log('all division',res.data)
        }
      })
      .catch((err) => {
        // console.log('Get all division error',err.message)
      });
  };
  const createDivision = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      name: DivisionUnit.name,
      description: DivisionUnit.description,
      hod: DivisionUnit?.hod,
      effective_start_date: DivisionUnit.effective_start_date,
      effective_status: DivisionUnit.effective_status,
    };
    // console.log('division data',data)
    await axios
      .post(createDivisionURL, data)
      .then((res) => {
        // console.log('division res',res.data)
        if (res.data.success === true) {
          DshandleClose();
          FetchAllDivision();
          setDivision({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          toast.success(res.data.message);
        }
        setloading(false);
      })
      .catch((err) => {
        DshandleClose();
        // toast.error(err.message)
        setloading(false);
      });
  };

  const updateDivision = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      division_id: editDs,
      name: DivisionUnit.name,
      description: DivisionUnit.description,
      hod: DivisionUnit?.hod,
      effective_start_date: DivisionUnit.effective_start_date,
      effective_status: DivisionUnit.effective_status,
    };
    // console.log('create job roles', data)
    await axios
      .post(editDivisionUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          DshandleClose();
          FetchAllDivision();
          setDivision({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          setEditDs(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        DshandleClose();
        setloading(false);
      });
  };

  const deleteDivision = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      division_id: deleteDs,
    };
    // console.log('create job roles', data)
    await axios
      .post(deleteDivisionUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          DshandleClose();
          handleDeleteDsClose();
          FetchAllDivision();
          setDivision({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          setDeleteDs(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        DshandleClose();
        setloading(false);
      });
  };

  const FetchAllDepartment = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allDepartmentURL, data)
      .then((res) => {
        if (res.data.success === true) {
          setAllDepartment(res.data.data);
          // console.log('all department',res.data)
        }
      })
      .catch((err) => {
        // console.log('Get all department error',err.message)
      });
  };
  const createDepartment = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      head_of_department: DepartmentUnit?.head_of_department,
      name: DepartmentUnit.name,
      description: DepartmentUnit.description,
      effective_start_date: DepartmentUnit.effective_start_date,
      effective_status: DepartmentUnit.effective_status,
    };
    await axios
      .post(creatDepartmentURL, data)
      .then((res) => {
        // console.log('division res',res.data)
        if (res.data.success === 1) {
          DepthandleClose();
          setDepartment({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          FetchAllDepartment();
          toast.success(res.data.message);
        }
        setloading(false);
      })
      .catch((err) => {
        DepthandleClose();
        // toast.error(err.message)
        setloading(false);
      });
  };

  const updateDepartment = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      department_id: editDept,
      head_of_department: DepartmentUnit?.head_of_department,
      name: DepartmentUnit.name,
      description: DepartmentUnit.description,
      effective_start_date: DepartmentUnit.effective_start_date,
      effective_status: DepartmentUnit.effective_status,
    };
    // console.log('create job roles', data)
    await axios
      .post(editDeparmentUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          DepthandleClose();
          setDepartment({
            name: "",
            description: "",
            effective_start_date: "",
            effective_status: "",
          });
          FetchAllDepartment();
          setEditDept(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        DepthandleClose();
        setloading(false);
      });
  };

  const deleteDepartment = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      department_id: deleteDept,
    };
    // console.log('create job roles', data)
    await axios
      .post(deleteDepartmentUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          FetchAllDepartment();
          setDeleteDept(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        DepthandleClose();
        setloading(false);
      });
  };

  const FetchAllGrade = async () => {
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayGradeURL, data)
      .then((res) => {
        setAllGrade(res.data);
      })
      .catch((err) => {
        // console.log('Get all pay grade error',err.message)
      });
  };
  const createPayGrade = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      grade: Grade.name,
      description: Grade.description,
      effective_start_date: Grade.start_date,
      effective_status: Grade.status,
      min_gross_salary: Grade.min_gross_salary,
      max_gross_salary: Grade.max_gross_salary,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };

    // console.log('pay grade post data',data)
    await axios
      .post(creatPayGradeURL, data)
      .then((res) => {
        if (res.data.success === true) {
          gradehandleClose();
          toast.success(res.data.data);
          setGrade({
            name: "",
            description: "",
            grade_status: "",
            start_date: "",
            status: "",
            min_gross_salary: "",
            max_gross_salary: "",
          });
          FetchAllGrade();
        }
        setloading(false);
      })
      .catch((err) => {
        gradehandleClose();
        setloading(false);
      });
  };

  const updatePayGrade = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      pay_grade_id: editGrade,
      grade: Grade.name,
      description: Grade.description,
      effective_start_date: Grade.start_date,
      effective_status: Grade.status,
      min_gross_salary: Grade.min_gross_salary,
      max_gross_salary: Grade.max_gross_salary,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };

    // console.log('pay grade post data',data)
    await axios
      .post(editPayGradeUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          gradehandleClose();
          handleEditGradeClose();
          toast.success(res.data.data);
          setGrade({
            name: "",
            description: "",
            grade_status: "",
            start_date: "",
            status: "",
            min_gross_salary: "",
            max_gross_salary: "",
          });
          FetchAllGrade();
        }
        setloading(false);
      })
      .catch((err) => {
        gradehandleClose();
        setloading(false);
      });
  };

  const deletePayGrade = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      pay_grade_id: editGrade,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };

    // console.log('pay grade post data',data)
    await axios
      .post(deletePayGradeUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          gradehandleClose();
          handleDeleteGradeClose();
          toast.success(res.data.data);
          setGrade({
            name: "",
            description: "",
            grade_status: "",
            start_date: "",
            status: "",
            min_gross_salary: "",
            max_gross_salary: "",
          });
          FetchAllGrade();
        }
        setloading(false);
      })
      .catch((err) => {
        gradehandleClose();
        setloading(false);
      });
  };

  const FetchAllLevel = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allPayLevelURL, data)
      .then((res) => {
        setAllLevel(res.data);
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };
  const createPayLevel = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      level: PayLevel.name,
      description: PayLevel.description,
      effective_start_date: PayLevel.start_date,
      effective_status: PayLevel.status,
      pay_grade_id: PayLevel.pay_grade_id,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    // console.log('create pay level', data)
    await axios
      .post(creatPayLevelURL, data)
      .then((res) => {
        if (res.data.success === true) {
          LevelhandleClose();
          setPayLevel({
            name: "",
            description: "",
            level: "",
            start_date: "",
            status: "",
            pay_grade_id: "",
          });
          FetchAllLevel();
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        LevelhandleClose();
        setloading(false);
      });
  };

  const updateCompanyPayLevel = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      pay_level_id: editPayLevel,
      level: PayLevel.name,
      description: PayLevel.description,
      effective_start_date: PayLevel.start_date,
      effective_status: PayLevel.status,
      pay_grade_id: PayLevel.pay_grade_id,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    // console.log('create pay level', data)
    await axios
      .post(editPayLevelUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          LevelhandleClose();
          handleEditPayLevelClose();
          setPayLevel({
            name: "",
            description: "",
            level: "",
            start_date: "",
            status: "",
            pay_grade_id: "",
          });
          FetchAllLevel();
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        LevelhandleClose();
        setloading(false);
      });
  };

  const deleteCompanyPayLevel = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      pay_level_id: deletePayLevel,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    // console.log('create pay level', data)
    await axios
      .post(deletePayLevelUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          LevelhandleClose();
          handleDeletePayLevelClose();
          setPayLevel({
            name: "",
            description: "",
            level: "",
            start_date: "",
            status: "",
            pay_grade_id: "",
          });
          FetchAllLevel();
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        LevelhandleClose();
        setloading(false);
      });
  };

  const FetchAllLocation = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allLocationURL, data)
      .then((res) => {
        setAllLocation(res?.data?.data);
      })
      .catch((err) => {
        // console.log('Get all pay level error',err.message)
      });
  };
  const createLocation = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      name: Location.name,
      head_of_location: Location?.head_of_location,
      description: Location.description,
      effective_start_date: Location.start_date,
    };
    // console.log('create pay level', data)
    await axios
      .post(createLocationURL, data)
      .then((res) => {
        if (res.data.success === true) {
          FetchAllLocation();
          LevelhandleClose();
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        LevelhandleClose();
        setloading(false);
      });
  };

  const updateLocation = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      location_id: editLocate,
      name: Location.name,
      head_of_location: Location?.head_of_location,
      description: Location.description,
      effective_start_date: Location.start_date,
    };
    // console.log('create pay level', data)
    await axios
      .post(editLocationUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          FetchAllLocation();
          handleEditLocateClose();
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        LevelhandleClose();
        setloading(false);
      });
  };

  const deleteLocation = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      location_id: deleteLocate,
    };
    // console.log('create pay level', data)
    await axios
      .post(deleteLocationUrl, data)
      .then((res) => {
        if (res.data.success === true) {
          FetchAllLocation();
          handleDeleteLocateClose();
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        LevelhandleClose();
        setloading(false);
      });
  };

  const FetchAllJobs = async () => {
    // console.log('all entity api')
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allJobRolesURL, data)
      .then((res) => {
        if (res.data?.success) {
          setAllJobs(res.data?.data);
        }
      })
      .catch((err) => {
        // console.log('Get all jobs error',err.message)
      });
  };

  const createJobRole = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      name: Job.name,
    };
    // console.log('create job roles', data)
    await axios
      .post(addJobRolesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          JobhandleClose();
          FetchAllJobs();
          setJob({ name: "" });
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        JobhandleClose();
        setloading(false);
      });
  };

  const updateJobRole = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      job_role_id: EditJob,
      name: Job.name,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    // console.log('create job roles', data)
    await axios
      .post(updateJobRolesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          JobhandleClose();
          FetchAllJobs();
          setEditJob(null);
          setJob({ name: "" });
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        JobhandleClose();
        setloading(false);
      });
  };

  const deleteJobRole = async () => {
    setloading(true);
    const data = {
      user_id: User?.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
      job_role_id: DeleteJob,
      proxy_id: proxyEmployee?.success ? proxyEmployee?.id : null,
    };
    // console.log('create job roles', data)
    await axios
      .post(deleteJobRolesURL, data)
      .then((res) => {
        if (res.data.success === true) {
          JobhandleClose();
          FetchAllJobs();
          setJob({ name: "" });
          setDeleteJob(null);
          toast.success(res.data.data);
        }
        setloading(false);
      })
      .catch((err) => {
        JobhandleClose();
        setloading(false);
      });
  };

  useEffect(() => {
    if (loadEndpoint) {
      GetAllCountry();
      AllLegalEntity();
      FetchAllBusinessUnit();
      FetchAllDivision();
      FetchAllDepartment();
      FetchAllGrade();
      FetchAllLevel();
      FetchAllLocation();
      FetchAllJobs();
      fetch();
    }
    // eslint-disable-next-line
  }, [loadEndpoint]);

  const dashboardTheme = window.localStorage.getItem("theme");

  useEffect(() => {}, [dashboardTheme]);

  return (
    <>
      <div className="Objects_Wrapper">
        {/* <div className="flex-container">
        <div className="row">
          <Draggable onPosChange={getChangedPos}>
            {words.map((word, idx) => {
              return (
                <div key={idx} className="flex-item">
                  {word}
                </div>
              );
            })}
          </Draggable>
        </div>
      </div> */}

        <div className={`Accordion_Wrapper ${Show === true ? "active" : ""}`}>
          <div className="Head" onClick={legalhandle}>
            <div className="Left">
              <div className="circle">
                {AllEntity === "" ? 0 : AllEntity?.length}
              </div>
              legal entity
            </div>
            <div className="Right">
              <div onClick={LegalhandleOpen} className="add_button">
                Add
              </div>
              {Show === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>name</th>
                <th>description</th>
                {/* <th>status</th> */}
                {/* <th>start date</th> */}
                {/* <th>pay group</th> */}
                {/* <th>country</th> */}
                {/* <th>hours</th>
                        <th>currency</th>
                        <th>Language</th> */}
                <th>action</th>
              </thead>
              <tbody>
                {AllEntity === "" && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No legal entity</div>
                    </td>
                  </tr>
                )}
                {AllEntity?.length > 0 &&
                  AllEntity.map((item, index) => (
                    <tr>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      {/* <td>{item.effective_status}</td> */}
                      {/* <td>{item.effective_start_date}</td> */}
                      {/* <td>{item.country}</td> */}
                      <td>
                          <div className="Action_Wrapper">
                            <span onClick={() => handleEditLegalOpen(item?.id)}>
                              <EditOutlinedIcon />
                            </span>
                            <span onClick={() => handleDeleteLegalOpen(item?.id)}>
                              <DeleteOutlineOutlinedIcon />
                            </span>
                          </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`Accordion_Wrapper Business ${
            BsShow === true ? "active" : ""
          }`}
        >
          <div className="Head" onClick={Bshandle}>
            <div className="Left">
              <div className="circle">
                {AllBusinessUnit === "" ? 0 : AllBusinessUnit.length}
              </div>
              Business Unit
            </div>
            <div className="Right">
              <div onClick={BshandleOpen} className="add_button">
                Add
              </div>
              {BsShow === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>name</th>
                <th>description</th>
                {/* <th>status</th> */}
                {/* <th>start date</th> */}
                {/* <th>head of unit</th> */}
                <th>action</th>
              </thead>
              <tbody>
                {AllBusinessUnit === "" && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No business unit</div>
                    </td>
                  </tr>
                )}
                {AllBusinessUnit.length > 0 &&
                  AllBusinessUnit.map((item, index) => (
                    <tr>
                      <td onClick={() => handleViewBsOpen(item)}>
                        {item.name}
                      </td>
                      <td onClick={() => handleViewBsOpen(item)}>
                        {item.description}
                      </td>
                      {/* <td>{item.effective_status}</td> */}
                      {/* <td>{item.effective_start_date}</td> */}
                      {/* <td>
                                    {item.unit_code}
                                </td> */}
                      <td>
                        <div className="Action_Wrapper">
                          <span onClick={() => handleEditBsOpen(item?.id)}>
                            <EditOutlinedIcon />
                          </span>
                          <span onClick={() => handleDeleteBsOpen(item?.id)}>
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`Accordion_Wrapper Business ${
            DsShow === true ? "active" : ""
          }`}
        >
          <div className="Head" onClick={Dshandle}>
            <div className="Left">
              <div className="circle">
                {AllDivision === "" ? 0 : AllDivision.length}
              </div>
              Division
            </div>
            <div className="Right">
              <div onClick={DshandleOpen} className="add_button">
                Add
              </div>
              {DsShow === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>name</th>
                <th>description</th>
                {/* <th>status</th> */}
                {/* <th>start date</th> */}
                {/* <th>head of unit</th> */}
                <th>action</th>
              </thead>
              <tbody>
                {AllDivision === "" && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No division</div>
                    </td>
                  </tr>
                )}
                {AllDivision.length > 0 &&
                  AllDivision.map((item, index) => (
                    <tr>
                      <td onClick={() => handleViewDsOpen(item)}>
                        {item.name}
                      </td>
                      <td onClick={() => handleViewDsOpen(item)}>
                        {item.description}
                      </td>
                      {/* <td>{item.effective_status}</td> */}
                      {/* <td>{item.effective_start_date}</td> */}
                      {/* <td>
                                    {item.unit_code}
                                </td> */}
                      <td>
                        <div className="Action_Wrapper">
                          <span onClick={() => handleEditDsOpen(item?.id)}>
                            <EditOutlinedIcon />
                          </span>
                          <span onClick={() => handleDeleteDsOpen(item?.id)}>
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`Accordion_Wrapper Department ${
            DeptShow === true ? "active" : ""
          }`}
        >
          <div className="Head" onClick={Depthandle}>
            <div className="Left">
              <div className="circle">
                {AllDepartment === "" ? 0 : AllDepartment.length}
              </div>
              Department
            </div>
            <div className="Right">
              <div onClick={DepthandleOpen} className="add_button">
                Add
              </div>
              {DeptShow === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>name</th>
                <th>description</th>
                {/* <th>status</th> */}
                {/* <th>start date</th> */}
                {/* <th>pt department</th> */}
                {/* <th>cost center</th> */}
                <th>action</th>
              </thead>
              <tbody>
                {AllDivision === "" && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No department</div>
                    </td>
                  </tr>
                )}
                {AllDepartment.length > 0 &&
                  AllDepartment.map((item, index) => (
                    <tr>
                      <td onClick={() => handleViewDeptOpen(item)}>
                        {item.name}
                      </td>
                      <td onClick={() => handleViewDeptOpen(item)}>
                        {item.description}
                      </td>
                      {/* <td>{item.effective_status}</td> */}
                      {/* <td>{item.effective_start_date}</td> */}
                      {/* <td>
                                    {item.unit_code}
                                </td> */}
                      <td>
                        <div className="Action_Wrapper">
                          <span onClick={() => handleEditDeptOpen(item?.id)}>
                            <EditOutlinedIcon />
                          </span>
                          <span onClick={() => handleDeleteDeptOpen(item?.id)}>
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`Accordion_Wrapper Cost ${
            GradeShow === true ? "active" : ""
          }`}
        >
          <div className="Head" onClick={Gradehandle}>
            <div className="Left">
              <div className="circle">
                {AllGrade === "" ? 0 : AllGrade.length}
              </div>
              Pay Grade
            </div>
            <div className="Right">
              <div onClick={gradehandleOpen} className="add_button">
                Add
              </div>
              {GradeShow === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>grade</th>
                <th>description</th>
                <th>action</th>
              </thead>
              <tbody>
                {AllGrade === "" && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No Grade</div>
                    </td>
                  </tr>
                )}
                {AllGrade.length > 0 &&
                  AllGrade.map((item, index) => (
                    <tr key={index}>
                      <td onClick={() => handleViewGradeOpen(item)}>
                        {item.grade}
                      </td>
                      <td onClick={() => handleViewGradeOpen(item)}>
                        {item.description}
                      </td>
                      <td>
                        <div className="Action_Wrapper">
                          <span onClick={() => handleEditGradeOpen(item?.id)}>
                            <EditOutlinedIcon />
                          </span>
                          <span onClick={() => handleDeleteGradeOpen(item?.id)}>
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`Accordion_Wrapper Cost ${
            PayLevelShow === true ? "active" : ""
          }`}
        >
          <div className="Head" onClick={Levelhandle}>
            <div className="Left">
              <div className="circle">
                {AllLevel === "" ? 0 : AllLevel.length}
              </div>
              Pay Level
            </div>
            <div className="Right">
              <div onClick={LevelhandleOpen} className="add_button">
                Add
              </div>
              {PayLevelShow === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>level</th>
                <th>description</th>
                <th>action</th>
              </thead>
              <tbody>
                {AllLevel === "" && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No Pay Level</div>
                    </td>
                  </tr>
                )}
                {AllLevel.length > 0 &&
                  AllLevel.map((item, index) => (
                    <tr key={index}>
                      <td onClick={() => handleViewLevelOpen(item)}>
                        {item.level}
                      </td>
                      <td onClick={() => handleViewLevelOpen(item)}>
                        {item.description}
                      </td>
                      <td>
                        <div className="Action_Wrapper">
                          <span
                            onClick={() => handleEditPayLevelOpen(item?.id)}
                          >
                            <EditOutlinedIcon />
                          </span>
                          <span
                            onClick={() => handleDeletePayLevelOpen(item?.id)}
                          >
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* <div onClick={Costhandle} className={`Accordion_Wrapper Cost ${CostShow===true ? "active" : ''}`}>
            <div className="Head">
                <div className="Left">
                    <div className="circle">0</div>
                    Cost centre
                </div>
                <div className="Right">
                    <div onClick={CosthandleOpen} className="add_button">Add</div>
                    {CostShow===false ? <ExpandMoreOutlinedIcon/> :<ExpandLessOutlinedIcon/>}
                </div>
            </div>
            <div className="Body">
                <table>
                    <thead>
                        <th>name</th>
                        <th>description</th>
                        <th>status</th>
                        <th>start date</th>
                        <th>cost center</th>
                        <th>cost center mgt</th>
                        <th>action</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan={10}>
                                <div className="NoData_Text">No legal entity</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> */}

        <div
          className={`Accordion_Wrapper Department ${
            LocateShow === true ? "active" : ""
          }`}
        >
          <div className="Head" onClick={Locatehandle}>
            <div className="Left">
              <div className="circle">
                {AllLocation === "" ? 0 : AllLocation?.length}
              </div>
              Location
            </div>
            <div className="Right">
              <div onClick={LocatehandleOpen} className="add_button">
                Add
              </div>
              {LocateShow === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>name</th>
                <th>description</th>
                {/* <th>start date</th> */}
                {/* <th>created date</th> */}
                <th>action</th>
              </thead>
              <tbody>
                {AllLocation === "" && (
                  <tr>
                    <td colSpan={5}>
                      <div className="NoData_Text">No location</div>
                    </td>
                  </tr>
                )}
                {AllLocation !== "" &&
                  AllLocation.map((item, index) => (
                    <tr key={index}>
                      <td onClick={() => handleViewLocateOpen(item)}>
                        {item.location}
                      </td>
                      <td onClick={() => handleViewLocateOpen(item)}>
                        {item.description}
                      </td>
                      {/* <td>{item.start_date}</td> */}
                      {/* <td>{item.created_at}</td> */}
                      <td>
                        <div className="Action_Wrapper">
                          <span onClick={() => handleEditLocateOpen(item?.id)}>
                            <EditOutlinedIcon />
                          </span>
                          <span
                            onClick={() => handleDeleteLocateOpen(item?.id)}
                          >
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div
          className={`Accordion_Wrapper ${JobShow === true ? "active" : ""}`}
        >
          <div className="Head" onClick={Jobhandle}>
            <div className="Left">
              <div className="circle">
                {AllJobs === "" ? 0 : AllJobs.length}
              </div>
              Job Roles
            </div>
            <div className="Right">
              <div onClick={JobhandleOpen} className="add_button">
                Add
              </div>
              {Show === false ? (
                <ExpandMoreOutlinedIcon />
              ) : (
                <ExpandLessOutlinedIcon />
              )}
            </div>
          </div>
          <div className="Body">
            <table>
              <thead>
                <th>name</th>
                {/* <th>description</th>
                <th>status</th>
                <th>start date</th> */}
                {/* <th>pay group</th> */}
                {/* <th>country</th> */}
                {/* <th>hours</th>
                        <th>currency</th>
                        <th>Language</th> */}
                <th>action</th>
              </thead>
              <tbody>
                {(AllJobs === "" || AllJobs.length < 1) && (
                  <tr>
                    <td colSpan={6}>
                      <div className="NoData_Text">No Jobs Role</div>
                    </td>
                  </tr>
                )}
                {AllJobs.length > 0 &&
                  AllJobs.map((item, index) => (
                    <tr key={index}>
                      <td onClick={() => handleViewJobOpen(item)}>
                        {item.name}
                      </td>
                      {/* <td>{item.description}</td>
                      <td>{item.effective_status}</td>
                      <td>{item.effective_start_date}</td>
                      <td>{item.country}</td> */}
                      <td>
                        <div className="Action_Wrapper">
                          <span onClick={() => handleEditJobOpen(item?.id)}>
                            <EditOutlinedIcon />
                          </span>
                          <span onClick={() => handleDeleteJobOpen(item?.id)}>
                            <DeleteOutlineOutlinedIcon />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={Costopen}
        onClose={CosthandleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={Costopen}>
          <Box sx={style}>
            {CostCenter.map((item, index) => (
              <div className="Form_Box" key={index}>
                <label>name</label>
                <input
                  name="name"
                  value={item.name}
                  onChange={(e) => handleCost(e, index)}
                  type="text"
                />
                <label>description</label>
                <input
                  name="description"
                  value={item.description}
                  onChange={(e) => handleCost(e, index)}
                  type="text"
                />
                <label>effective Status</label>
                <select
                  name="effectiveStatus"
                  value={item.effectiveStatus}
                  onChange={(e) => handleCost(e, index)}
                  id=""
                >
                  <option value="">--choose--</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <label>effective Start Date</label>
                <input
                  name="effectiveStartDate"
                  value={item.effectiveStartDate}
                  onChange={(e) => handleCost(e, index)}
                  type="date"
                />
                <label>head Of Unit</label>
                <input
                  name="headOfUnit"
                  value={item.headOfUnit}
                  onChange={(e) => handleCost(e, index)}
                  type="text"
                />
                <label>parent Department</label>
                <select
                  name="parentDepartment"
                  value={item.parentDepartment}
                  onChange={(e) => handleCost(e, index)}
                  id=""
                >
                  <option value="">--choose--</option>
                  <option value="Yes">Dept one</option>
                  <option value="No">Dept two</option>
                </select>
                <label>parent Cost Center</label>
                <select
                  name="parentCostCenter"
                  value={item.parentCostCenter}
                  onChange={(e) => handleCost(e, index)}
                  id=""
                >
                  <option value="">--choose--</option>
                  <option value="Yes">Cost center one</option>
                  <option value="No">Cost center two</option>
                </select>
                <label>cost Center Manager</label>
                <select
                  name="costCenterManager"
                  value={item.costCenterManager}
                  onChange={(e) => handleCost(e, index)}
                  id=""
                >
                  <option value="">--choose--</option>
                  <option value="Yes">Cost center one</option>
                  <option value="No">Cost center two</option>
                </select>
              </div>
            ))}
            <div className="Form_Btn_Wrapper">
              <button
                onClick={submitCost}
                style={{
                  backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
                }}
              >
                submit
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          <div className="foundation_header">
            Create Legal Entity Country Specific
          </div>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <div className="Form_Box">
            <div className="Box">
              <label>name</label>
              <input
                name="name"
                className={`${errors.name && "active"}`}
                {...register("name", { required: true })}
              />
              {errors.name && <p>Name is required.</p>}
            </div>

            <div className="Box">
              <label>description</label>
              <input
                name="description"
                className={`${errors.description && "active"}`}
                {...register("description", { required: true })}
              />
              {errors.description && <p>Description is required.</p>}
            </div>

            <div className="Box">
              <label>effective Status</label>
              <select
                name="effectiveStatus"
                className={`${errors.effectiveStatus && "active"}`}
                {...register("effectiveStatus", { required: true })}
                id=""
              >
                <option value="">Choose status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.effectiveStatus && <p>Effective status is required.</p>}
            </div>

            <div className="Box">
              <label>effective Start Date</label>
              <input
                type="date"
                name=""
                id=""
                className={`${errors.effectiveStartDate && "active"}`}
                {...register("effectiveStartDate", { required: true })}
              />
              {errors.effectiveStartDate && (
                <p>Effective start date is required.</p>
              )}
            </div>

            <div className="Box">
              <label>country Of Registration</label>
              <select
                name="countryOfRegistration"
                className={`${errors.countryOfRegistration && "active"}`}
                {...register("countryOfRegistration", { required: true })}
                id=""
              >
                <option value="">Choose country</option>
                {Country !== "" &&
                  Country.map((item, index) => (
                    <option value={item.country}>{item.country}</option>
                  ))}
              </select>
              {errors.countryOfRegistration && (
                <p>Country of registration is required.</p>
              )}
            </div>
            <div className="Box">
              <label>official Language</label>
              <textarea
                name="officialLanguage"
                id=""
                cols="30"
                rows="10"
                className={`${errors.official_language && "active"}`}
                {...register("official_language", { required: true })}
              ></textarea>
              {errors.official_language && (
                <p>Official language is required.</p>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="Form_Btn_Wrapper">
            <button onClick={handleClose} className="Btn">
              Cancel
            </button>
            <button
              className="Btn"
              onClick={Legalsubmit}
              style={{
                backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
              }}
            >
              {isLoading === true ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                "submit"
              )}
            </button>
          </div>
        </DialogActions>
      </BootstrapDialog>

      {/* Legal Entity Foundational Dialog */}
      <CreateLegalEntityDialog
        LegalhandleClose={LegalhandleClose}
        Legalopen={Legalopen}
        LegalEntity={LegalEntity}
        setLegalEntity={setLegalEntity}
        errors={errors}
        createLegalEntity={Legalsubmit}
        isLoading={isLoading}
        AllEmployee={AllEmployee}
      />

      <EditLegalDialog
        handleEditLegalClose={handleEditLegalClose}
        editLegal={editLegal}
        LegalEntity={LegalEntity}
        setLegalEntity={setLegalEntity}
        updateLegalEntity={updateLegalEntity}
        isLoading={isLoading}
      />

      <DeleteLegalDialog
        handleDeleteLegalClose={handleDeleteLegalClose}
        deleteLegal={deleteLegal}
        deleteLegalEntity={deleteLegalEntity}
        isLoading={isLoading}
      />

      <ViewLegalDialog
        handleViewLegalClose={handleViewLegalClose}
        LegalViewopen={LegalViewopen}
      />

      {/* Business Unit Foundational Dialog */}
      <CreateBusinessUnitDialog
        BshandleClose={BshandleClose}
        Bsopen={Bsopen}
        BusinessUnit={BusinessUnit}
        setBusiness={setBusiness}
        AllEmployee={AllEmployee}
        errors={errors}
        createBusinessUnit={createBusinessUnit}
        isLoading={isLoading}
      />
      <EditBusinessUnitDialog
        handleEditBsClose={handleEditBsClose}
        editBs={editBs}
        BusinessUnit={BusinessUnit}
        setBusiness={setBusiness}
        AllEmployee={AllEmployee}
        errors={errors}
        updateBusinessUnit={updateBusinessUnit}
        isLoading={isLoading}
      />
      <DeleteBusinessUnitDialog
        handleDeleteBsClose={handleDeleteBsClose}
        deleteBs={deleteBs}
        deleteBusinessUnit={deleteBusinessUnit}
        isLoading={isLoading}
      />

      <ViewBusinessUnitDialog
        handleViewBsClose={handleViewBsClose}
        BsViewopen={BsViewopen}
        employee={AllEmployee?.find(
          (item) => item.value === BsViewopen?.head_of_unit
        )}
      />

      {/* Division Foundational Dialog */}
      <CreateDivisionDialog
        DshandleClose={DshandleClose}
        Dsopen={Dsopen}
        DivisionUnit={DivisionUnit}
        setDivision={setDivision}
        AllEmployee={AllEmployee}
        createDivision={createDivision}
        isLoading={isLoading}
      />
      <EditDivisionDialog
        handleEditDsClose={handleEditDsClose}
        editDs={editDs}
        DivisionUnit={DivisionUnit}
        setDivision={setDivision}
        AllEmployee={AllEmployee}
        updateDivision={updateDivision}
        isLoading={isLoading}
      />
      <DeleteDivisionDialog
        handleDeleteDsClose={handleDeleteDsClose}
        deleteDs={deleteDs}
        isLoading={isLoading}
        deleteDivision={deleteDivision}
      />

      <ViewDivisionDialog
        handleViewDsClose={handleViewDsClose}
        DsViewopen={DsViewopen}
        employee={AllEmployee?.find((item) => item.value === DsViewopen?.hod)}
      />

      {/* Department Foundational Dialog */}
      <CreateDepartmentDialog
        DepthandleClose={DepthandleClose}
        Deptopen={Deptopen}
        DepartmentUnit={DepartmentUnit}
        setDepartment={setDepartment}
        AllEmployee={AllEmployee}
        createDepartment={createDepartment}
        isLoading={isLoading}
      />
      <EditDepartmentDialog
        handleEditDeptClose={handleEditDeptClose}
        editDept={editDept}
        DepartmentUnit={DepartmentUnit}
        setDepartment={setDepartment}
        AllEmployee={AllEmployee}
        updateDepartment={updateDepartment}
        isLoading={isLoading}
      />
      <DeleteDepartmentDialog
        handleDeleteDeptClose={handleDeleteDeptClose}
        deleteDept={deleteDept}
        isLoading={isLoading}
        deleteDepartment={deleteDepartment}
      />

      <ViewDepartmentDialog
        handleViewDeptClose={handleViewDeptClose}
        DeptViewopen={DeptViewopen}
        employee={AllEmployee?.find(
          (item) => item.value === DeptViewopen?.head_of_department
        )}
      />

      {/* Grade Foundational Modal */}
      <CreateGradesDialog
        gradehandleClose={gradehandleClose}
        openGrade={openGrade}
        Grade={Grade}
        setGrade={setGrade}
        createPayGrade={createPayGrade}
        isLoading={isLoading}
      />

      <EditGradeDialog
        handleEditGradeClose={handleEditGradeClose}
        editGrade={editGrade}
        Grade={Grade}
        setGrade={setGrade}
        updateGrade={updatePayGrade}
        isLoading={isLoading}
      />

      <DeleteGradeDialog
        handleDeleteGradeClose={handleDeleteGradeClose}
        deleteGrade={deleteGrade}
        deletePayGrade={deletePayGrade}
        isLoading={isLoading}
      />

      <ViewGradeDialog
        handleViewGradeClose={handleViewGradeClose}
        GradeViewopen={GradeViewopen}
      />

      {/* Levels Foundational Modal */}
      <CreateLevelsDialog
        LevelhandleClose={LevelhandleClose}
        openLevel={openLevel}
        PayLevel={PayLevel}
        setPayLevel={setPayLevel}
        AllGrade={AllGrade}
        createPayLevel={createPayLevel}
        isLoading={isLoading}
      />

      <EditLevelDialog
        handleEditLevelClose={handleEditPayLevelClose}
        editPayLevel={editPayLevel}
        PayLevel={PayLevel}
        setPayLevel={setPayLevel}
        AllGrade={AllGrade}
        updateCompanyPayLevel={updateCompanyPayLevel}
        isLoading={isLoading}
      />

      <DeleteLevelDialog
        handleDeletePayLevelClose={handleDeletePayLevelClose}
        deletePayLevel={deletePayLevel}
        deleteCompanyLevel={deleteCompanyPayLevel}
        isLoading={isLoading}
      />

      <ViewLevelDialog
        handleViewLevelClose={handleViewLevelClose}
        LevelViewopen={LevelViewopen}
        grade={
          AllGrade !== "" &&
          AllGrade?.find((item) => item?.id === LevelViewopen?.pay_grade_id)
        }
      />

      {/* Location Foundational Modals */}
      <CreateLocationDialog
        LocatehandleClose={LocatehandleClose}
        Locateopen={Locateopen}
        Location={Location}
        setLocation={setLocation}
        AllEmployee={AllEmployee}
        submitlocation={submitlocation}
        isLoading={isLoading}
      />
      <EditLocationDialog
        handleEditLocateClose={handleEditLocateClose}
        editLocate={editLocate}
        AllLocation={AllLocation}
        Location={Location}
        setLocation={setLocation}
        AllEmployee={AllEmployee}
        updateLocation={updateLocation}
        isLoading={isLoading}
      />
      <DeleteLocationDialog
        handleDeleteLocateClose={handleDeleteLocateClose}
        deleteLocate={deleteLocate}
        isLoading={isLoading}
        deleteLocation={deleteLocation}
      />
      <ViewLocationDialog
        handleViewLocateClose={handleViewLocateClose}
        LocateViewopen={LocateViewopen}
        employee={AllEmployee?.find(
          (item) => item.value === LocateViewopen?.head_of_location
        )}
      />

      {/* Job Roles Foundational Modal */}
      <CreateJobroles
        JobhandleClose={JobhandleClose}
        JobOpen={JobOpen}
        Job={Job}
        setJob={setJob}
        createJobRole={createJobRole}
        isLoading={isLoading}
      />
      <EditJobroles
        handleEditJobClose={handleEditJobClose}
        EditJob={EditJob}
        Job={Job}
        setJob={setJob}
        AllJobs={AllJobs}
        updateJobRole={updateJobRole}
        isLoading={isLoading}
      />
      <DeleteJobroles
        handleDeleteJobClose={handleDeleteJobClose}
        DeleteJob={DeleteJob}
        deleteJobRole={deleteJobRole}
        isLoading={isLoading}
      />
      <ViewJobDialog
        handleViewJobClose={handleViewJobClose}
        JobViewopen={JobViewopen}
      />
    </>
  );
};

export default FoundationObject;
